module.exports = __webpack_public_path__ + "img/青丘.ab623099.png";